const ROUGHNESS_FACTOR = 0.4;

/**
 * Format yaw/pitch/roll for model-viewer orientation attribute.
 * @param {number[]|string[]|null|undefined} orientation [yaw, pitch, roll] in degrees
 * @returns {string}
 */
function formatModelOrientation( orientation ) {
	const defaults = [ 0, 0, 0 ];
	const values =
		Array.isArray( orientation ) && orientation.length >= 3 ? orientation : defaults;

	return values
		.slice( 0, 3 )
		.map( ( value ) => {
			const str = String( value ).trim();
			return str.endsWith( 'deg' ) ? str : `${ str }deg`;
		} )
		.join( ' ' );
}

class fl_model_viewer {
	constructor( glb_url_array, placements, add_to_selector, file_m_time, orientation ) {
		this.add_to_selector = add_to_selector;
		this.glb_url_array = glb_url_array;
		this.placements = placements;
		this.model_orientation = formatModelOrientation( orientation );
		this.model_viewer = document.createElement( 'model-viewer' );
		this.file_m_time = file_m_time;
		this.init_model_viewer( this.model_viewer, 'flt-model' );
		this.append_model_viewer_to_dom( jQuery( add_to_selector ) );
		this.load_glb_model( this.model_viewer, 'flt-model' );
		this.applyRoughnessToAllMaterials( this.model_viewer );
		this.add_fancybox_link( jQuery( add_to_selector ) );
	}

	init_model_viewer( mv_object, id ) {
		mv_object.id = id;
		mv_object.setAttribute( 'ar', '' );
		mv_object.setAttribute( 'ar-modes', 'webxr scene-viewer quick-look' );
		mv_object.setAttribute( 'camera-controls', '' );
		mv_object.setAttribute( 'shadow-intensity', '1' );
		mv_object.setAttribute( 'touch-action', 'pan-y' );
		mv_object.setAttribute( 'auto-rotate', '500' );
		mv_object.setAttribute( 'disable-pan', '' );
		mv_object.setAttribute( 'interaction-prompt', 'auto' );
		mv_object.setAttribute( 'field-of-view', '25deg' );
		mv_object.setAttribute( 'max-camera-orbit', 'auto auto auto' );
		mv_object.setAttribute( 'camera-orbit', '-45deg 75deg 4m' );
		mv_object.setAttribute( 'orientation', this.model_orientation );
		var width = jQuery( this.add_to_selector ).outerWidth() + 'px';
		mv_object.setAttribute(
			'style',
			'display:block; width: ' + width + '; height: ' + width + '; background-color: #ffffff;'
		);
	}

	append_model_viewer_to_dom( add_to ) {
		add_to.append( this.model_viewer );

		const modelViewer = document.querySelector( 'model-viewer' );
		const shadowRoot = modelViewer && modelViewer.shadowRoot;
		const loadingBar = shadowRoot && shadowRoot.querySelector( '.progress-bar' );
		if ( loadingBar ) {
			loadingBar.style.display = 'none';
		}
	}

	async load_glb_model( mv_object, id ) {
		if ( this.glb_url_array.length === 1 ) {
			mv_object.setAttribute( 'src', this.glb_url_array[0] );
		} else if ( this.glb_url_array.length > 1 ) {
			try {
				const { GLBModelMerger } = await import(
					`${ window.location.origin }/wp-content/themes/storefrontfeatherlight_bvh/common_js/utils/GLBModelMerger.js?v=${ this.file_m_time }`
				);
				const glbFiles = this.glb_url_array.map( ( url ) => `${ window.location.origin }${ url }` );
				const mirrors = [];
				new GLBModelMerger( glbFiles, this.placements, mirrors, id );
			} catch ( error ) {
				console.error( 'Failed to load GLBModelMerger: ', error );
			}
		}
	}

	/**
	 * Uniform roughness for all materials (replaces per-color preset tables).
	 */
	applyRoughnessToAllMaterials( modelViewer ) {
		modelViewer.addEventListener( 'load', () => {
			const materials = modelViewer.model && modelViewer.model.materials;
			if ( ! materials || ! materials.length ) {
				return;
			}
			for ( let i = 0; i < materials.length; i++ ) {
				const material = materials[ i ];
				if ( material.pbrMetallicRoughness ) {
					material.pbrMetallicRoughness.setRoughnessFactor( ROUGHNESS_FACTOR );
				}
			}
		} );
	}

	add_fancybox_link( add_to ) {
		if ( ! jQuery( '.gallery-images' ).length ) {
			return;
		}

		const container = document.createElement( 'div' );
		container.style.textAlign = 'center';

		const fancyboxLink = document.createElement( 'a' );
		fancyboxLink.className = 'fullscreen-link';
		fancyboxLink.href = 'javascript:;';
		fancyboxLink.textContent = text.zoom;
		fancyboxLink.setAttribute( 'style', 'background-color: rgba(255, 255, 255, 0.7);' );
		fancyboxLink.setAttribute( 'data-fancybox', '' );
		fancyboxLink.setAttribute( 'data-src', '#fancybox-model-popup' );
		fancyboxLink.setAttribute( 'data-options', JSON.stringify( { touch: false } ) );
		fancyboxLink.style.display = 'block';
		fancyboxLink.style.position = 'relative';
		fancyboxLink.style.fontSize = '0.85em';
		fancyboxLink.style.zIndex = '0';

		container.append( this.model_viewer );
		add_to.append( container );

		const fancyboxPopup = document.getElementById( 'fancybox-model-popup' );
		if ( ! fancyboxPopup ) {
			return;
		}

		fancyboxPopup.innerHTML = '';

		const fancyboxModelViewer = document.createElement( 'model-viewer' );
		fancyboxModelViewer.id = 'flt-model-popup';

		this.init_model_viewer( fancyboxModelViewer, fancyboxModelViewer.id );

		fancyboxModelViewer.setAttribute( 'camera-controls', '' );
		fancyboxModelViewer.setAttribute( 'shadow-intensity', '1' );
		fancyboxModelViewer.setAttribute( 'auto-rotate', '' );
		fancyboxModelViewer.setAttribute( 'camera-orbit', '-75deg 75deg 40cm' );
		fancyboxModelViewer.setAttribute( 'ar', '' );
		fancyboxModelViewer.setAttribute( 'ar-modes', 'webxr scene-viewer quick-look' );
		fancyboxModelViewer.setAttribute( 'auto-rotate', '500' );
		fancyboxModelViewer.setAttribute( 'disable-pan', '' );
		fancyboxModelViewer.setAttribute( 'interaction-prompt', 'auto' );
		fancyboxModelViewer.setAttribute( 'field-of-view', '25deg' );

		fancyboxModelViewer.style.width = '100vw';
		fancyboxModelViewer.style.height = '100vw';
		fancyboxModelViewer.style.maxWidth = '500px';
		fancyboxModelViewer.style.maxHeight = '500px';

		fancyboxPopup.appendChild( fancyboxModelViewer );

		this.load_glb_model( fancyboxModelViewer, fancyboxModelViewer.id );
		this.applyRoughnessToAllMaterials( fancyboxModelViewer );
	}
}
